import { isGroupTableQuery } from 'owa-group-common';
import { getSelectedTableView } from 'owa-mail-list-store';
export default function isGroupTableSelected() {
    var selectedTable = getSelectedTableView();
    return selectedTable && isGroupTableQuery(selectedTable.tableQuery);
}
//# sourceMappingURL=isGroupTableSelected.js.map